import { Sort } from '../interfaces/sort';
import { Identifier } from './identifier';
import { After, Before } from './utils';

export class IdentificationPriority<T extends Record<string, any>>
  implements Sort<T>
{
  constructor(public readonly items: T[], public readonly key: string) {}

  sort(): T[] {
    return [...this.items].sort((a, b) => {
      if (this.priority(a, b)) {
        return new After().priority();
      }
      return new Before().priority();
    });
  }

  priority(a: T, b: T): boolean {
    const idA = new Identifier(a, this.key).value();
    const idB = new Identifier(b, this.key).value();
    return idA > idB;
  }
}
